module.exports = __webpack_public_path__ + "img/icon_unclassified_msg_delete.svg";